import React, { useRef, useState } from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import LazyLoad from "react-lazyload";

import GoogleAds from "../GoogleAds";

import * as styles from "./CourseItems.module.css";

const WordPageLink = ({ label, wordURL }) =>
  wordURL ? (
    <Link
      style={{
        color: "#1c2f46",
        textDecoration: "none",
      }}
      to={wordURL}
    >
      {label}
    </Link>
  ) : (
    label
  );

const CourseItems = ({ items, shouldDisplayAd, playText }) => {
  const audioRefs = useRef({});
  const [playingItemIndex, setPlayingItemIndex] = useState(null);

  const handlePlay = (newPlayingItemIndex) => {
    const audioElement = audioRefs.current[newPlayingItemIndex];
    if (newPlayingItemIndex !== playingItemIndex) {
      if (playingItemIndex !== null) {
        const prevAudioElement = audioRefs.current[playingItemIndex];
        prevAudioElement.pause();
        prevAudioElement.currentTime = 0;
      }
      audioElement.play();
      setPlayingItemIndex(newPlayingItemIndex);
    } else if (audioElement.ended) {
      audioElement.play();
    }
  };

  return (
    <ul
      style={{
        listStyle: "none",
        padding: 0,
      }}
    >
      {items.map((item, itemIndex) => {
        const wordToLearn = item.word;
        const wordTranslation = item.translation;
        const withEmoji = !!item.emoji;
        return (
          <React.Fragment key={item.word}>
            <li
              style={{
                display: "flex",
                padding: "10px 15px",
                backgroundColor: "#f6f7fb",
                marginBottom: "15px",
                border: "1px solid #ddd",
                borderRadius: 5,
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
              }}
            >
              {withEmoji && <div style={{ fontSize: 75, marginRight: 30 }}>{item.emoji}</div>}
              {!withEmoji && (
                <LazyLoad
                  style={{
                    width: 75,
                    height: 75,
                    marginRight: 30,
                  }}
                  height={75}
                  once
                >
                  {item.imageURL && (
                    <img src={item.imageURL} width={75} height={75} alt={wordToLearn} />
                  )}
                </LazyLoad>
              )}

              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                  }}
                >
                  <span
                    style={{
                      marginRight: 10,
                    }}
                  >
                    <WordPageLink label={wordToLearn} wordURL={item.wordURL} />
                  </span>

                  {item.audioURL && (
                    <div
                      onClick={() => {
                        handlePlay(itemIndex);
                      }}
                    >
                      <button
                        name={`play ${wordToLearn}`}
                        onClick={() => {}}
                        className={styles.playButton}
                        aria-label={playText}
                      >
                        <StaticImage
                          src="../../images/play-button-arrowhead.svg"
                          alt={playText}
                          height={20}
                          width={20}
                        />
                      </button>
                      <audio
                        ref={(el) => {
                          audioRefs.current[itemIndex] = el;
                        }}
                        src={item.audioURL}
                        preload="none"
                      ></audio>
                    </div>
                  )}
                </div>
                {item.wordSimple && (
                  <div style={{ marginTop: 2 }}>
                    <WordPageLink label={item.wordSimple} wordURL={item.wordURL} />
                  </div>
                )}
                {item.wordPro && (
                  <div>
                    <WordPageLink label={item.wordPro} wordURL={item.wordURL} />
                  </div>
                )}
                <div style={{ marginTop: 3 }}>
                  <span>
                    <WordPageLink label={wordTranslation} wordURL={item.wordURL} />
                  </span>
                </div>
              </div>
            </li>
            {shouldDisplayAd && shouldDisplayAd(itemIndex) && (
              <li
                style={{
                  padding: "0 15px",
                  marginBottom: "15px",
                  boxSizing: "border-box",
                }}
              >
                <GoogleAds slot="5181655559" layoutKey="-fb+5w+4e-db+86" />
              </li>
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
};

export default CourseItems;
